import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { html } from 'lit';
import { BreakPoints } from '../constants/breakpoints.ts';

export interface ImgInterface {
    src: string;
    alt: string;
    lazy: string;
    fetchpriority?: string;
    mediumSrc: string;
    largeSrc: string;
    xLargeSrc: string;
    imgClass?: string;
}

export const getImage = (props: ImgInterface) => {
    const optLazy = props.lazy == 'true' ? ` loading='lazy'` : '';
    const options = `${optLazy}`;
    const image = unsafeHTML(
        `<img fetchpriority='${props.fetchpriority}' src='${props.src}' alt='${props.alt}' ${options} part="image"/>`
    );
    return html`
        <picture>
            <source
                srcset="${props.xLargeSrc}"
                media="(min-width: ${BreakPoints.XLARGE})" />
            <source
                srcset="${props.largeSrc}"
                media="(min-width: ${BreakPoints.LARGE})" />
            <source
                srcset="${props.mediumSrc}"
                media="(min-width: ${BreakPoints.MEDIUM})" />
            ${image}
        </picture>
    `;
};
